import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=65123035&scoped=true&"
import script from "./discount.vue?vue&type=script&lang=js&"
export * from "./discount.vue?vue&type=script&lang=js&"
import style0 from "./discount.vue?vue&type=style&index=0&id=65123035&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65123035",
  null
  
)

export default component.exports